var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { colors } from '../../styles';
var CloseHint = function (_a) {
    var _b = _a.color, color = _b === void 0 ? colors.primary : _b, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "22", height: "22", fill: "none", fillRule: "evenodd" }, props),
        React.createElement("circle", { cx: "11", cy: "11", r: "11", fill: color }),
        React.createElement("g", { stroke: "#fff", strokeLinecap: "round", strokeWidth: "3" },
            React.createElement("path", { d: "M7.314 15.274L14.995 6" }),
            React.createElement("path", { transform: "matrix(.999391 .034899 .034899 -.999391 5.432155 15.482906)", d: "M9.55.543l-8 9" }))));
};
export default CloseHint;
//# sourceMappingURL=CloseHint.js.map